import { on, fire } from 'delegated-events';
import autosize from 'autosize';
import tailSelect from '../vendor/tail.select';
import helpers from './helpers.js';

/*
===========================================
Form Helpers
===========================================
*/
export default (function () {
  return {
    init() {
      this.styledSelects();
      this.multiSelects();
      this.postChanges();
      this.textareas();
      this.styledCheckboxes();
      this.resetButton();
	  this.vacancyForm();
    },
    styledSelects() {
      // Styled select boxes
      const selects = document.querySelectorAll('select:not([size]):not([multiple]):not(.js-custom-select)');

      helpers.forEach(selects, (i, select) => {
        if (select.closest('.styled-select') !== null) return;
        const className = select.getAttribute('class' !== null) ? select.getAttribute('class') : '';
        const wrapper = document.createElement('div');
        wrapper.className = `styled-select ${className}`;
        helpers.wrap(select, wrapper);
      });

      const styledSelects = document.querySelectorAll('.styled-select');

      helpers.forEach(styledSelects, (i, styledSelect) => {
        const sel = styledSelect.querySelector('select');

        if (styledSelect.querySelector('.styled-select__label') === null) {
          styledSelect.insertAdjacentHTML('afterbegin', '<span class="styled-select__label"></span>');
        }

        const label = styledSelect.querySelector('.styled-select__label');

        sel.addEventListener('focus', (e) => {
          e.stopPropagation();
          helpers.addClass(sel.parentNode, 'styled-select--focus');
        });

        sel.addEventListener('blur', (e) => {
          e.stopPropagation();
          helpers.removeClass(sel.parentNode, 'styled-select--focus');
        });

        function setval() {
          if (sel.matches(':disabled')) {
            helpers.addClass(styledSelect, 'disabled');
          } else {
            helpers.removeClass(styledSelect, 'disabled');
          }
          label.innerHTML = sel.options[sel.selectedIndex].text;
        }
        setval();

        sel.removeEventListener('change', setval);
        sel.addEventListener('change', setval);
      });
    },
    multiSelects() {
      const multiSelects = document.querySelectorAll('select.js-multi-select:not(.js-profile-filter-select)');

      if (multiSelects.length) {
        [...multiSelects].forEach((el, i) => {
          const multiContainer = el.getAttribute('data-container');
          const options = {
            multiShowCount: false,
            sourceBind: true,
            csvOutput: true,
            multiContainer,
          };
          tailSelect(el, options);
        });
      }
    },
    updateCheckboxes() {
      const styledSelects = document.querySelectorAll('.styled-select');

      helpers.forEach(styledSelects, (i, styledSelect) => {
        const sel = styledSelect.querySelector('select');
        const label = styledSelect.querySelector('.styled-select__label');
        function setval() {
          if (sel.matches(':disabled')) {
            helpers.addClass(styledSelect, 'disabled');
          } else {
            helpers.removeClass(styledSelect, 'disabled');
          }
          label.innerHTML = sel.options[sel.selectedIndex].text;
        }
        setval();
      });
    },
    styledCheckboxes() {
      const inputs = document.querySelectorAll('.sc-form input[type=checkbox], .sc-form input[type=radio]');
      [...inputs].forEach((el) => {
        const type = el.getAttribute('type');
        // Wrap the text in a span
        const wrapper = document.createElement('span');
        wrapper.className = `${type}__label`;
        helpers.wrap(el.nextSibling, wrapper);
        el.closest('label').classList.add(type);
      });
    },
    postChanges() {
      const postChanges = document.querySelectorAll('.js-postchanges');
      let postTimer = null;

      if (postChanges.length) {
        helpers.forEach(postChanges, (i, el) => {
          el.addEventListener('change', (e) => {
            postTimer = setTimeout(() => {
              e.target.closest('form').submit();
            }, 500);
          });
        });
      }
    },
    resetButton() {
      on('click', '.js-reset', (e) => {
        e.preventDefault();
        const form = e.target.closest('form, .js-form');
        form.reset();
        const multiSelects = form.querySelectorAll('select.js-multi-select');
        [...multiSelects].forEach((el) => {
          [...el.querySelectorAll('option')].forEach((option) => {
            option.removeAttribute('selected');
          });
          fire(el, 'change');
        });
        this.updateCheckboxes();
      });
    },
    vacancyForm() {
      const form = document.querySelector('.filters__form');
	  if(!form) return;
	  const selectSearch = form.querySelectorAll('.select-search');
      form.addEventListener('submit', (e) => {
        selectSearch.forEach(el => {
          if(el.value.length < 1) {
            el.name = '';
		  }
        });
      });
    },
    textareas() {
      autosize(document.querySelectorAll('textarea.js-autosize, .sc-form textarea'));
    },
  };
})();
